import React, { useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Building2, LayoutGrid, MessageSquareWarning, ScrollText } from "lucide-react";
import { ENTERPRISE_CONTROL_BASE } from "../enterprise-control/constants";
import PortalSidebar from "../../enterprise/admin-shared/PortalSidebar";
import { confirmAndLogout } from "../utils/auth";
import nyafazLogo from "../../salon-admin/assets/nyafazlogo.png";

const PortalHeadSidebar = ({ expanded, setExpanded }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewport, setViewport] = useState("desktop");

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 768) setViewport("mobile");
      else if (w < 1367) setViewport("tablet");
      else setViewport("desktop");
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const sidebarPath =
    location.pathname.startsWith("/nyafaz-portal/products/salon") ||
    location.pathname.startsWith("/nyafaz-portal/products/brand")
      ? "/nyafaz-portal/home"
      : location.pathname === ENTERPRISE_CONTROL_BASE ||
          location.pathname.startsWith(`${ENTERPRISE_CONTROL_BASE}/`)
        ? "/nyafaz-portal/home"
        : location.pathname;

  const menuItems = useMemo(() => {
    const items = [
      {
        key: "portal-home",
        sectionId: "overview",
        IconComponent: LayoutGrid,
        label: "Overview",
        to: "/nyafaz-portal/home",
      },
      {
        key: "portal-orgs",
        sectionId: "organization",
        IconComponent: Building2,
        label: "All organizations",
        to: "/nyafaz-portal/organizations",
      },
    ];

    items.push(
      {
        key: "escalated",
        sectionId: "about",
        IconComponent: MessageSquareWarning,
        label: "Escalated support",
        to: "/nyafaz-portal/escalated-complaints",
      },
      {
        key: "release-notes",
        sectionId: "about",
        IconComponent: ScrollText,
        label: "Release notes",
        to: "/nyafaz-portal/release-notes",
      },
    );

    return items;
  }, []);

  const isCompactViewport = viewport === "tablet" || viewport === "mobile";

  return (
    <PortalSidebar
      menuItems={menuItems}
      releaseNotesPath="/nyafaz-portal/release-notes"
      logoSrc={nyafazLogo}
      logoFallback={nyafazLogo}
      expanded={expanded}
      setExpanded={setExpanded}
      onLogout={() => confirmAndLogout(navigate)}
      isCompactViewport={isCompactViewport}
      locationPathname={sidebarPath}
    />
  );
};

export default PortalHeadSidebar;
